import React, { useEffect, useRef, useState } from "react";
import "./Prie.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import phone from "../../../Assets/phone.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LinkedINImage from "../../../Assets/linkedin.svg";
import massageicon from "../../../Assets/FrameDiff.svg";
import company from "../../../Assets/people-logo.png";
import education from "../../../Assets/cap-logo.png";
import experience from "../../../Assets/jobcompany.png";
import ReplayIcon from "@mui/icons-material/Replay";
import linkedin from "../../../Assets/linkedin.svg";
import visitLinkImage from "../../../Assets/visit-link.svg";
import { APIUrlThree, APIUrlToken } from "../../../Utils/Utils";
import axios from "axios";
import { CloseOutlined } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useLocation, useNavigate } from "react-router-dom";
import partnerimg from "../../../Assets/partnerimg.svg";
import joformarimg from "../../../Assets/joformernew.svg";
import moment from "moment";
import PrieMenu from "./PrieMenu";
import { APP_CONFIG} from "../../../Utils/env";

const PrieDirectPath = ({
  dataForInformation,
  crieDataInitial,
  crieData,
  setCrieData,
  crieSrcList,
  joAssociateList,
  setJoAssociateList,
  setModalOpen,
  setLoading,
  handleRadioChange,
  selectedValue,
  disabledIndirect,
  setModalOpenRefresh,
  isMobile,
  indirectCount,
  inDirectSummary,
  isTabPortrait,
}) => {
  const navigate = useNavigate();
  const [visibleItems, setVisibleItems] = useState(10);
  const itemsPerLoad = 10;
  const handleLoadMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + itemsPerLoad);
  };
  const [isMenuJoassociate, setIsMenuJoassociate] = React.useState(false);
  const [joassociate, setJoassociate] = React.useState([]);
  const handleChangeJoAssociate = (event, item) => {
    if (event.target.checked) {
      setJoassociate([...joassociate, item]);
    } else {
      setJoassociate(joassociate?.filter((uncheck) => uncheck !== item));
    }
  };
  const handleSearchJoAssociate = (e) => {
    if (e?.length) {
      const data = crieSrcList?.filter((item) =>
        item?.name?.toLowerCase()?.includes(e?.toLowerCase()),
      );
      setJoAssociateList(data);
    } else {
      setJoAssociateList(crieSrcList);
    }
  };
  // Path Weight
  const allPathWeightdata = [
    {
      name: "Extra Strong 85-100",
      value: [85, 100],
    },
    {
      name: "Strong 71-84",
      value: [71, 84],
    },
    {
      name: "Slightly Strong 57-70",
      value: [57, 70],
    },
    {
      name: "Neutral 43-56",
      value: [43, 56],
    },
    {
      name: "Slightly Weak 29-42",
      value: [29, 42],
    },
    {
      name: "Weak 15-28",
      value: [15, 28],
    },
    {
      name: "Extra Weak 1-14",
      value: [1, 14],
    },
  ];
  const [isMenuPathWeight, setIsMenuPathWeight] = React.useState(false);
  const [pathWeight, setPathWeight] = React.useState([]);
  const [pathWeightList, setPathWeightList] = useState(allPathWeightdata);

  const handleChangePathWeight = (event, item) => {
    if (event.target.checked) {
      setPathWeight([...pathWeight, item]);
    } else {
      setPathWeight(pathWeight?.filter((uncheck) => uncheck !== item));
    }
  };

  useEffect(() => {
    setJoassociate([]);
    setPathWeight([]);
  }, [dataForInformation]);

  const handleSearchCrie = () => {
    setIsMenuJoassociate(false);
    setIsMenuPathWeight(false);
    const data = {};
    if (joassociate?.length) {
      data.src_id = joassociate;
    }
    data.dest_id = [`${dataForInformation?.person_id}`];
    if (pathWeight?.length) {
      data.strength = pathWeight;
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlThree()}/v1/get_crie?src_org_id=${
        // process.env.REACT_APP_JOI_JO_ID
        APP_CONFIG.JOI_JO_ID
      }`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data;
          setCrieData(data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleResetFilter = () => {
    setCrieData(crieDataInitial);
    setJoassociate([]);
    setPathWeight([]);
  };
  const joRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (joRef.current && !joRef.current.contains(event.target)) {
        setIsMenuJoassociate(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [joRef]);

  const pathRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pathRef.current && !pathRef.current.contains(event.target)) {
        setIsMenuPathWeight(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pathRef]);

  const getDaysDifference = (date) => {
    const diff = moment().diff(moment(date), "days");

    if (diff >= 366) {
      return { text: "1 year+", color: "rgb(207 74 74)" };
    } else if (diff >= 181) {
      return { text: "< 1 year", color: "#EC971E" };
    } else if (diff >= 91) {
      return { text: "< 6 months", color: "#C601A2" };
    } else if (diff >= 31) {
      return { text: "< 3 months", color: "#0195C6" };
    } else {
      return { text: "< 1 month", color: "rgb(90 194 157)" };
    }
  };

  // useEffect(() => {
  //     handleSearchCrie()
  // }, [])
  const [isPortrait, setIsPortrait] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };
    // set initial value
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  const getInitials = (name) => {
    return name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };
  return (
    <>
      {" "}
      {isMobile ? (
        <div>
          <div
            className={`crie-filter-inner-container ${
              disabledIndirect === "submitted" ? "crie-cont-x" : "crie-cont-2"
            } do_not_print`}
          >
            <div className="crie-inner-drop-boxes">
              {/* Jo Associate */}
              <div className="crie_outer_drop">
                <div
                  className="crie-drop-down"
                  style={{ textTransform: "none" }}
                  onClick={() => {
                    setIsMenuJoassociate(!isMenuJoassociate);
                    setJoAssociateList(crieSrcList);
                    setIsMenuPathWeight(false);
                  }}
                >
                  JO Employee
                  <KeyboardArrowDownIcon />
                </div>
                <div ref={joRef}>
                  <PrieMenu
                    isMenuOpen={isMenuJoassociate}
                    alldata={joAssociateList}
                    handleCheckboxChange={handleChangeJoAssociate}
                    checked={joassociate}
                    handleSearch={handleSearchJoAssociate}
                    isSearch={true}
                  />
                </div>
              </div>

              {/* Path weight */}
              <div className="crie_outer_drop">
                <div
                  className="crie-drop-down"
                  onClick={() => {
                    setIsMenuPathWeight(!isMenuPathWeight);
                    setIsMenuJoassociate(false);
                    setJoAssociateList(crieSrcList);
                  }}
                >
                  Path Strength
                  <KeyboardArrowDownIcon />
                </div>
                <div ref={pathRef}>
                  <PrieMenu
                    isMenuOpen={isMenuPathWeight}
                    alldata={pathWeightList}
                    handleCheckboxChange={handleChangePathWeight}
                    checked={pathWeight}
                    isSearch={false}
                  />
                </div>
              </div>
              {
                <Button
                  onClick={handleSearchCrie}
                  className="crie-filter-inner-container-search"
                >
                  Search
                </Button>
              }

              {/* Reset Filter */}
              {
                <div className="crie_outer_drop">
                  <div
                    className="inner-rest-button-crie"
                    onClick={handleResetFilter}
                  >
                    <ReplayIcon className="reset-tick-icon" />
                    Reset Filter
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="crie-filter-inner-container cre-list-cont">
            <div className="crie-inner-drop-boxes-2">
              {joassociate?.length ? (
                <>
                  {joassociate?.map((item) => (
                    <div className="crie_selected_names">
                      {joAssociateList?.find((i) => i?.value == item)?.name}{" "}
                      <CloseOutlined
                        onClick={() =>
                          setJoassociate(
                            joassociate?.filter((uncheck) => uncheck !== item),
                          )
                        }
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </div>

            <div className="crie-inner-drop-boxes-2">
              {pathWeight?.length ? (
                <>
                  {pathWeight?.map((item) => (
                    <div className="crie_selected_names">
                      {
                        pathWeightList?.find(
                          (i) =>
                            i?.value?.[0] == item?.[0] &&
                            i?.value?.[1] == item?.[1],
                        )?.name
                      }{" "}
                      <CloseOutlined
                        onClick={() =>
                          setPathWeight(
                            pathWeight?.filter((uncheck) => uncheck !== item),
                          )
                        }
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </div>
          </div>
          {/* <div className='crie-cont crie_direct'>Direct Connection Paths</div> */}
          <div style={{ padding: isPortrait ? "0px" : "20px" }}>
            <div className="path-graph-crie">
              <div>
                <p className="directpath-crie">
                  {crieData?.length} Direct Paths{" "}
                  {(disabledIndirect === "processing" && indirectCount) ||
                  (disabledIndirect === "refresh" && indirectCount)
                    ? `| ${indirectCount || 0} Indirect paths`
                    : null}{" "}
                  found as of{" "}
                  {inDirectSummary?.generated_date
                    ? moment(inDirectSummary?.generated_date).format("M.DD.YY")
                    : moment(inDirectSummary?.generated_date).format("M.DD.YY")}
                </p>
              </div>{" "}
              <div className="radio-input-crie">
                {/* <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    className="rg-direct-paths"
                    onChange={(e) => handleRadioChange(e)}
                  >
                    <FormControlLabel
                      className="direct-path-crie"
                      checked={selectedValue === "direct"}
                      value="direct"
                      control={<Radio />}
                      label="Direct Paths"
                    />
                    <FormControlLabel
                      className={
                        disabledIndirect == "pending" ||
                        disabledIndirect === "submitted"
                          ? "in-direct-path-crie"
                          : "direct-path-crie"
                      }
                      checked={selectedValue === "indirect"}
                      value="indirect"
                      disabled={
                        disabledIndirect == "pending" ||
                        disabledIndirect === "submitted"
                      }
                      control={<Radio />}
                      label="Indirect Paths"
                    />
                  </RadioGroup>
                </FormControl> */}
                <FormControl>
                  <RadioGroup
                    row
                    value={selectedValue}
                    onChange={handleRadioChange}
                    sx={{
                      borderBottom: "1px solid #e0e0e0",
                      gap: 3,
                    }}
                  >
                    <FormControlLabel
                      value="direct"
                      control={<Radio sx={{ display: "none" }} />}
                      label="Direct Paths"
                      sx={{
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: selectedValue === "direct" ? 600 : 400,
                        color:
                          selectedValue === "direct" ? "#d32f2f" : "#6b7280",
                        paddingBottom: "8px",
                        borderBottom:
                          selectedValue === "direct"
                            ? "2px solid #d32f2f"
                            : "2px solid #e0e0e0",
                      }}
                    />

                    <FormControlLabel
                      value="indirect"
                      disabled={
                        disabledIndirect === "pending" ||
                        disabledIndirect === "submitted"
                      }
                      control={<Radio sx={{ display: "none" }} />}
                      label="Indirect Paths"
                      sx={{
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: selectedValue === "indirect" ? 600 : 400,
                        color:
                          disabledIndirect === "pending" ||
                          disabledIndirect === "submitted"
                            ? "#9ca3af"
                            : selectedValue === "indirect"
                              ? "#d32f2f"
                              : "#6b7280",
                        paddingBottom: "8px",
                        borderBottom:
                          selectedValue === "indirect"
                            ? "2px solid #d32f2f"
                            : "2px solid transparent",
                      }}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {disabledIndirect === "pending" ? (
                <Button
                  style={{ width: "100%", fontWeight: "500" }}
                  className="crie-filter-inner-container-crie"
                  onClick={() => setModalOpen(true)}
                >
                  Enable Indirect Connection Paths
                </Button>
              ) : null}
              {disabledIndirect === "submitted" ? (
                <div className="crie_indirect_process">
                  <p style={{ fontSize: "12px" }}>Indirect Paths In Process</p>
                  <Button
                    className="crie-filter-inner-container-crie-disabled"
                    style={{ width: "100%", fontWeight: "500" }}
                  >
                    Enable Indirect Connection Paths
                  </Button>
                </div>
              ) : null}
              {disabledIndirect === "processing" ? (
                <Button
                  style={{ width: "100%", fontWeight: "500" }}
                  className="crie-filter-inner-container-crie"
                  onClick={() => setModalOpenRefresh(true)}
                >
                  Refresh Indirect Paths
                </Button>
              ) : null}
              {disabledIndirect === "refresh" ? (
                <div className="crie_indirect_process">
                  <p style={{ fontSize: "12px" }}>Indirect Paths In Process</p>
                  <Button
                    className="crie-filter-inner-container-crie-disabled"
                    style={{ width: "100%", fontWeight: "500" }}
                  >
                    Refresh Indirect Paths
                  </Button>
                </div>
              ) : null}
              {crieData?.length ? (
                <>
                  {crieData
                    .sort((a, b) => b.strength - a.strength)
                    ?.slice(0, visibleItems)
                    ?.map((item, index) => (
                      <div className="crie_path_cont-mob">
                        <div
                          className="first_crie_box"
                          // onClick={() => {
                          //   if (item?.src_org_id) {
                          //     navigate(`/Profile/${item?.src_id}`);
                          //   }
                          // }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <p
                              style={{
                                backgroundColor: "#3B82F6",
                                height: "40px",
                                width: "40px",
                                borderRadius: "30px",
                                color: "#ffffff",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              {getInitials(item?.src_name)}
                            </p>{" "}
                          </div>

                          <div className="crie_info">
                            <div className="crie_name">
                              {item?.src_name}{" "}
                              <p className="formerjo-p">
                                {item.src_former_jo ? (
                                  <img
                                    src={joformarimg}
                                    alt=""
                                    className="jo-former-icon"
                                  />
                                ) : (
                                  ""
                                )}
                              </p>{" "}
                            </div>
                            <div>Jobs Ohio</div>
                            <a className="company-profile-mention">
                              {" "}
                              <EmailOutlinedIcon
                                style={{
                                  color: "#003057",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />{" "}
                              {item?.src_email
                                ? item?.src_email.split(",")[0]
                                : "--"}
                            </a>
                            <a className="company-profile-mention">
                              {" "}
                              <img
                                src={phone}
                                alt=""
                                style={{ width: "13px", height: "13px" }}
                              />
                              {item?.src_phone ? item?.src_phone : "--"}{" "}
                            </a>
                            <p className="company-profile-mention-2">
                              <span>
                                <img
                                  src={linkedin}
                                  alt=""
                                  style={{ width: "14px", height: "14px" }}
                                />
                                {item?.src_linkedin ? "Linkedin Profile" : "--"}
                              </span>
                              {item?.src_linkedin ? (
                                <a
                                  href={item?.src_linkedin}
                                  target="_blank"
                                  className="crie-a-end"
                                >
                                  {" "}
                                  <img
                                    src={visitLinkImage}
                                    alt=""
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </a>
                              ) : (
                                <a></a>
                              )}{" "}
                            </p>
                          </div>
                          <div>
                            <IconButton
                              component="a"
                              href={`mailto:${item?.src_email}`}
                              color="error"
                              className="aip-email"
                            >
                              <EmailOutlinedIcon />
                            </IconButton>
                          </div>
                        </div>
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {item?.last_date && item?.last_date !== "-" ? (
                            <div
                              className="prie-days-mob"
                              style={{
                                background: getDaysDifference(item.last_date)
                                  .color,
                              }}
                            >
                              {getDaysDifference(item?.last_date).text}
                            </div>
                          ) : null}
                          <div className="prie-img-mob">
                            <Tooltip title={"Weighted Connection Strength"}>
                              <div className="weight-between-nodes-prie-mob">
                                {item?.strength}
                              </div>
                            </Tooltip>
                            <div className="prie_line-mob"> </div>

                            {item?.connection_types?.includes("Email") ? (
                              <Tooltip title={"Email Exchanged"}>
                                <img
                                  src={massageicon}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("LinkedIn") ? (
                              <Tooltip title={"LinkedIn Connection"}>
                                <img
                                  src={LinkedINImage}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}
                            {item?.connection_types?.includes(
                              "Organization",
                            ) ? (
                              <Tooltip title={"Working in Same Organization"}>
                                <img
                                  src={company}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Education") ? (
                              <Tooltip title={"Attended Same College"}>
                                <img
                                  src={education}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Experience") ? (
                              <Tooltip
                                title={"Previously Worked in Same Organization"}
                              >
                                <img
                                  src={experience}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Meeting") ? (
                              <Tooltip title={"Meeting"}>
                                <CalendarMonthIcon className="siderbar-modal-img" />
                              </Tooltip>
                            ) : null}
                            {item?.connection_types?.includes("Partner") ? (
                              <Tooltip title={"Regional Partner"}>
                                <img
                                  src={partnerimg}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}
                          </div>
                        </div>
                        <div
                          className="first_crie_box"
                          // onClick={() => {
                          //   if (item?.dst_org_id) {
                          //     navigate(`/Profile/${item?.dst_id}`);
                          //   }
                          // }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <p
                              style={{
                                backgroundColor: "#3B82F6",
                                height: "40px",
                                width: "40px",
                                borderRadius: "30px",
                                color: "#ffffff",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              {getInitials(item?.dst_name)}
                            </p>{" "}
                          </div>

                          <div className="crie_info">
                            <div className="crie_name">
                              {item?.dst_name}{" "}
                              <p className="formerjo-p">
                                {item.dst_former_jo ? (
                                  <img
                                    src={joformarimg}
                                    alt=""
                                    className="jo-former-icon"
                                  />
                                ) : (
                                  ""
                                )}
                              </p>{" "}
                            </div>
                            <div className="crie_name">
                              {dataForInformation?.name}
                            </div>
                            <a className="company-profile-mention">
                              {" "}
                              <EmailOutlinedIcon
                                style={{
                                  color: "#003057",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />{" "}
                              {item?.dst_email ? item?.dst_email : "--"}{" "}
                            </a>
                            <a className="company-profile-mention">
                              {" "}
                              <img
                                src={phone}
                                alt=""
                                style={{ width: "13px", height: "13px" }}
                              />
                              {item?.dst_phone ? item?.dst_phone : "--"}
                            </a>
                            <p className="company-profile-mention-2">
                              <span>
                                <img
                                  src={linkedin}
                                  alt=""
                                  style={{ width: "14px", height: "14px" }}
                                />
                                {item?.dst_linkedin ? "Linkedin Profile" : "--"}
                              </span>{" "}
                              {item?.dst_linkedin ? (
                                <a
                                  href={item?.dst_linkedin}
                                  className="crie-a-end"
                                  target="_blank"
                                >
                                  {" "}
                                  <img
                                    src={visitLinkImage}
                                    alt=""
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </a>
                              ) : null}{" "}
                            </p>
                          </div>
                          <div>
                            <IconButton
                              component="a"
                              href={`mailto:${item?.dst_email}`}
                              color="error"
                              className="aip-email"
                            >
                              <EmailOutlinedIcon />
                            </IconButton>
                          </div>
                        </div>

                        <div
                          style={{
                            width: "100%",

                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <div
                            style={{
                              width: "100%",
                              height: "2px",
                              background: "#DA291C",
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <div className="crie_path_cont-mob">No Records Found !</div>
              )}
              <div className="loadmore-pagination-section">
                {visibleItems < crieData?.length ? (
                  <button
                    className="btn-load-more button-loadmore-pagination crie-load-more"
                    onClick={handleLoadMore}
                  >
                    Load More
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : isTabPortrait ? (
        <div>
          <div
            className={`crie-filter-inner-container ${
              disabledIndirect === "submitted" ? "crie-cont-x" : "crie-cont-2"
            } do_not_print`}
          >
            <div className="crie-inner-drop-boxes">
              {/* Jo Associate */}
              <div className="crie_outer_drop">
                <div
                  className="crie-drop-down"
                  style={{ textTransform: "none" }}
                  onClick={() => {
                    setIsMenuJoassociate(!isMenuJoassociate);
                    setJoAssociateList(crieSrcList);
                    setIsMenuPathWeight(false);
                  }}
                >
                  JO Employee
                  <KeyboardArrowDownIcon />
                </div>
                <div ref={joRef}>
                  <PrieMenu
                    isMenuOpen={isMenuJoassociate}
                    alldata={joAssociateList}
                    handleCheckboxChange={handleChangeJoAssociate}
                    checked={joassociate}
                    handleSearch={handleSearchJoAssociate}
                    isSearch={true}
                  />
                </div>
              </div>

              {/* Path weight */}
              <div className="crie_outer_drop">
                <div
                  className="crie-drop-down"
                  onClick={() => {
                    setIsMenuPathWeight(!isMenuPathWeight);
                    setIsMenuJoassociate(false);
                    setJoAssociateList(crieSrcList);
                  }}
                >
                  Path Strength
                  <KeyboardArrowDownIcon />
                </div>
                <div ref={pathRef}>
                  <PrieMenu
                    isMenuOpen={isMenuPathWeight}
                    alldata={pathWeightList}
                    handleCheckboxChange={handleChangePathWeight}
                    checked={pathWeight}
                    isSearch={false}
                  />
                </div>
              </div>
              {
                <Button
                  onClick={handleSearchCrie}
                  className="crie-filter-inner-container-search"
                >
                  Search
                </Button>
              }

              {/* Reset Filter */}
              {
                <div className="crie_outer_drop">
                  <div
                    className="inner-rest-button-crie"
                    onClick={handleResetFilter}
                  >
                    <ReplayIcon className="reset-tick-icon" />
                    Reset Filter
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="crie-filter-inner-container cre-list-cont">
            <div className="crie-inner-drop-boxes-2">
              {joassociate?.length ? (
                <>
                  {joassociate?.map((item) => (
                    <div className="crie_selected_names">
                      {joAssociateList?.find((i) => i?.value == item)?.name}{" "}
                      <CloseOutlined
                        onClick={() =>
                          setJoassociate(
                            joassociate?.filter((uncheck) => uncheck !== item),
                          )
                        }
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </div>

            <div className="crie-inner-drop-boxes-2">
              {pathWeight?.length ? (
                <>
                  {pathWeight?.map((item) => (
                    <div className="crie_selected_names">
                      {
                        pathWeightList?.find(
                          (i) =>
                            i?.value?.[0] == item?.[0] &&
                            i?.value?.[1] == item?.[1],
                        )?.name
                      }{" "}
                      <CloseOutlined
                        onClick={() =>
                          setPathWeight(
                            pathWeight?.filter((uncheck) => uncheck !== item),
                          )
                        }
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </div>
          </div>
          {/* <div className='crie-cont crie_direct'>Direct Connection Paths</div> */}
          <div style={{ padding: isPortrait ? "0px" : "20px" }}>
            <div className="path-graph-crie">
              <div>
                <p className="directpath-crie">
                  {crieData?.length} Direct Paths{" "}
                  {(disabledIndirect === "processing" && indirectCount) ||
                  (disabledIndirect === "refresh" && indirectCount)
                    ? `| ${indirectCount || 0} Indirect paths`
                    : null}{" "}
                  found as of{" "}
                  {inDirectSummary?.generated_date
                    ? moment(inDirectSummary?.generated_date).format("M.DD.YY")
                    : moment(inDirectSummary?.generated_date).format("M.DD.YY")}
                </p>
              </div>{" "}
              <div className="radio-input-crie">
                {/* <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    className="rg-direct-paths"
                    onChange={(e) => handleRadioChange(e)}
                  >
                    <FormControlLabel
                      className="direct-path-crie"
                      checked={selectedValue === "direct"}
                      value="direct"
                      control={<Radio />}
                      label="Direct Paths"
                    />
                    <FormControlLabel
                      className={
                        disabledIndirect == "pending" ||
                        disabledIndirect === "submitted"
                          ? "in-direct-path-crie"
                          : "direct-path-crie"
                      }
                      checked={selectedValue === "indirect"}
                      value="indirect"
                      disabled={
                        disabledIndirect == "pending" ||
                        disabledIndirect === "submitted"
                      }
                      control={<Radio />}
                      label="Indirect Paths"
                    />
                  </RadioGroup>
                </FormControl> */}
                <FormControl>
                  <RadioGroup
                    row
                    value={selectedValue}
                    onChange={handleRadioChange}
                    sx={{
                      borderBottom: "1px solid #e0e0e0",
                      gap: 3,
                    }}
                  >
                    <FormControlLabel
                      value="direct"
                      control={<Radio sx={{ display: "none" }} />}
                      label="Direct Paths"
                      sx={{
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: selectedValue === "direct" ? 600 : 400,
                        color:
                          selectedValue === "direct" ? "#d32f2f" : "#6b7280",
                        paddingBottom: "8px",
                        borderBottom:
                          selectedValue === "direct"
                            ? "2px solid #d32f2f"
                            : "2px solid #e0e0e0",
                      }}
                    />

                    <FormControlLabel
                      value="indirect"
                      disabled={
                        disabledIndirect === "pending" ||
                        disabledIndirect === "submitted"
                      }
                      control={<Radio sx={{ display: "none" }} />}
                      label="Indirect Paths"
                      sx={{
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: selectedValue === "indirect" ? 600 : 400,
                        color:
                          disabledIndirect === "pending" ||
                          disabledIndirect === "submitted"
                            ? "#9ca3af"
                            : selectedValue === "indirect"
                              ? "#d32f2f"
                              : "#6b7280",
                        paddingBottom: "8px",
                        borderBottom:
                          selectedValue === "indirect"
                            ? "2px solid #d32f2f"
                            : "2px solid transparent",
                      }}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {disabledIndirect === "pending" ? (
                <Button
                  style={{ width: "100%", fontWeight: "500" }}
                  className="crie-filter-inner-container-crie"
                  onClick={() => setModalOpen(true)}
                >
                  Enable Indirect Connection Paths
                </Button>
              ) : null}
              {disabledIndirect === "submitted" ? (
                <div className="crie_indirect_process">
                  <p style={{ fontSize: "12px" }}>Indirect Paths In Process</p>
                  <Button
                    className="crie-filter-inner-container-crie-disabled"
                    style={{ width: "100%", fontWeight: "500" }}
                  >
                    Enable Indirect Connection Paths
                  </Button>
                </div>
              ) : null}
              {disabledIndirect === "processing" ? (
                <Button
                  style={{ width: "100%", fontWeight: "500" }}
                  className="crie-filter-inner-container-crie"
                  onClick={() => setModalOpenRefresh(true)}
                >
                  Refresh Indirect Paths
                </Button>
              ) : null}
              {disabledIndirect === "refresh" ? (
                <div className="crie_indirect_process">
                  <p style={{ fontSize: "12px" }}>Indirect Paths In Process</p>
                  <Button
                    className="crie-filter-inner-container-crie-disabled"
                    style={{ width: "100%", fontWeight: "500" }}
                  >
                    Refresh Indirect Paths
                  </Button>
                </div>
              ) : null}
              {crieData?.length ? (
                <>
                  {crieData
                    .sort((a, b) => b.strength - a.strength)
                    ?.slice(0, visibleItems)
                    ?.map((item, index) => (
                      <div className="crie_path_cont-mob">
                        <div
                          className="first_crie_box"
                          // onClick={() => {
                          //   if (item?.src_org_id) {
                          //     navigate(`/Profile/${item?.src_id}`);
                          //   }
                          // }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <p
                              style={{
                                backgroundColor: "#3B82F6",
                                height: "40px",
                                width: "40px",
                                borderRadius: "30px",
                                color: "#ffffff",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              {getInitials(item?.src_name)}
                            </p>{" "}
                          </div>

                          <div className="crie_info">
                            <div className="crie_name">
                              {item?.src_name}{" "}
                              <p className="formerjo-p">
                                {item.src_former_jo ? (
                                  <img
                                    src={joformarimg}
                                    alt=""
                                    className="jo-former-icon"
                                  />
                                ) : (
                                  ""
                                )}
                              </p>{" "}
                            </div>
                            <div>Jobs Ohio</div>
                            <a className="company-profile-mention">
                              {" "}
                              <EmailOutlinedIcon
                                style={{
                                  color: "#003057",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />{" "}
                              {item?.src_email
                                ? item?.src_email.split(",")[0]
                                : "--"}
                            </a>
                            <a className="company-profile-mention">
                              {" "}
                              <img
                                src={phone}
                                alt=""
                                style={{ width: "13px", height: "13px" }}
                              />
                              {item?.src_phone ? item?.src_phone : "--"}{" "}
                            </a>
                            <p className="company-profile-mention-2">
                              <span>
                                <img
                                  src={linkedin}
                                  alt=""
                                  style={{ width: "14px", height: "14px" }}
                                />
                                {item?.src_linkedin ? "Linkedin Profile" : "--"}
                              </span>
                              {item?.src_linkedin ? (
                                <a
                                  href={item?.src_linkedin}
                                  target="_blank"
                                  className="crie-a-end"
                                >
                                  {" "}
                                  <img
                                    src={visitLinkImage}
                                    alt=""
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </a>
                              ) : (
                                <a></a>
                              )}{" "}
                            </p>
                          </div>
                          <div>
                            <IconButton
                              component="a"
                              href={`mailto:${item?.src_email}`}
                              color="error"
                              className="aip-email"
                            >
                              <EmailOutlinedIcon />
                            </IconButton>
                          </div>
                        </div>
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap:"5px"
                          }}
                        >
                          {item?.last_date && item?.last_date !== "-" ? (
                            <div
                              className="prie-days-mob"
                              style={{
                                background: getDaysDifference(item.last_date)
                                  .color,
                              }}
                            >
                              {getDaysDifference(item?.last_date).text}
                            </div>
                          ) : null}
                          <div className="prie-img-mob">
                            <Tooltip title={"Weighted Connection Strength"}>
                              <div className="weight-between-nodes-prie-mob">
                                {item?.strength}
                              </div>
                            </Tooltip>
                            <div className="prie_line-mob"> </div>

                            {item?.connection_types?.includes("Email") ? (
                              <Tooltip title={"Email Exchanged"}>
                                <img
                                  src={massageicon}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("LinkedIn") ? (
                              <Tooltip title={"LinkedIn Connection"}>
                                <img
                                  src={LinkedINImage}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}
                            {item?.connection_types?.includes(
                              "Organization",
                            ) ? (
                              <Tooltip title={"Working in Same Organization"}>
                                <img
                                  src={company}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Education") ? (
                              <Tooltip title={"Attended Same College"}>
                                <img
                                  src={education}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Experience") ? (
                              <Tooltip
                                title={"Previously Worked in Same Organization"}
                              >
                                <img
                                  src={experience}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Meeting") ? (
                              <Tooltip title={"Meeting"}>
                                <CalendarMonthIcon className="siderbar-modal-img" />
                              </Tooltip>
                            ) : null}
                            {item?.connection_types?.includes("Partner") ? (
                              <Tooltip title={"Regional Partner"}>
                                <img
                                  src={partnerimg}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}
                          </div>
                        </div>
                        <div
                          className="first_crie_box"
                          // onClick={() => {
                          //   if (item?.dst_org_id) {
                          //     navigate(`/Profile/${item?.dst_id}`);
                          //   }
                          // }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <p
                              style={{
                                backgroundColor: "#3B82F6",
                                height: "40px",
                                width: "40px",
                                borderRadius: "30px",
                                color: "#ffffff",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              {getInitials(item?.dst_name)}
                            </p>{" "}
                          </div>

                          <div className="crie_info">
                            <div className="crie_name">
                              {item?.dst_name}{" "}
                              <p className="formerjo-p">
                                {item.dst_former_jo ? (
                                  <img
                                    src={joformarimg}
                                    alt=""
                                    className="jo-former-icon"
                                  />
                                ) : (
                                  ""
                                )}
                              </p>{" "}
                            </div>
                            <div className="crie_name">
                              {dataForInformation?.name}
                            </div>
                            <a className="company-profile-mention">
                              {" "}
                              <EmailOutlinedIcon
                                style={{
                                  color: "#003057",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />{" "}
                              {item?.dst_email ? item?.dst_email : "--"}{" "}
                            </a>
                            <a className="company-profile-mention">
                              {" "}
                              <img
                                src={phone}
                                alt=""
                                style={{ width: "13px", height: "13px" }}
                              />
                              {item?.dst_phone ? item?.dst_phone : "--"}
                            </a>
                            <p className="company-profile-mention-2">
                              <span>
                                <img
                                  src={linkedin}
                                  alt=""
                                  style={{ width: "14px", height: "14px" }}
                                />
                                {item?.dst_linkedin ? "Linkedin Profile" : "--"}
                              </span>{" "}
                              {item?.dst_linkedin ? (
                                <a
                                  href={item?.dst_linkedin}
                                  className="crie-a-end"
                                  target="_blank"
                                >
                                  {" "}
                                  <img
                                    src={visitLinkImage}
                                    alt=""
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </a>
                              ) : null}{" "}
                            </p>
                          </div>
                          <div>
                            <IconButton
                              component="a"
                              href={`mailto:${item?.dst_email}`}
                              color="error"
                              className="aip-email"
                            >
                              <EmailOutlinedIcon />
                            </IconButton>
                          </div>
                        </div>

                        <div
                          style={{
                            width: "100%",

                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <div
                            style={{
                              width: "100%",
                              height: "2px",
                              background: "#DA291C",
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <div className="crie_path_cont-mob">No Records Found !</div>
              )}
              <div className="loadmore-pagination-section">
                {visibleItems < crieData?.length ? (
                  <button
                    className="btn-load-more button-loadmore-pagination crie-load-more"
                    onClick={handleLoadMore}
                  >
                    Load More
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )  : (
        // web view

        <div>
          <div
            className={`crie-filter-inner-container ${
              disabledIndirect === "submitted" ? "crie-cont-x" : "crie-cont-2"
            } do_not_print`}
          >
            <div className="crie-inner-drop-boxes">
              {/* Jo Associate */}
              <div className="crie_outer_drop">
                <div
                  className="crie-drop-down"
                  style={{ textTransform: "none" }}
                  onClick={() => {
                    setIsMenuJoassociate(!isMenuJoassociate);
                    setJoAssociateList(crieSrcList);
                    setIsMenuPathWeight(false);
                  }}
                >
                  JO Employee
                  <KeyboardArrowDownIcon />
                </div>
                <div ref={joRef}>
                  <PrieMenu
                    isMenuOpen={isMenuJoassociate}
                    alldata={joAssociateList}
                    handleCheckboxChange={handleChangeJoAssociate}
                    checked={joassociate}
                    handleSearch={handleSearchJoAssociate}
                    isSearch={true}
                  />
                </div>
              </div>

              {/* Path weight */}
              <div className="crie_outer_drop">
                <div
                  className="crie-drop-down"
                  onClick={() => {
                    setIsMenuPathWeight(!isMenuPathWeight);
                    setIsMenuJoassociate(false);
                    setJoAssociateList(crieSrcList);
                  }}
                >
                  Path Strength
                  <KeyboardArrowDownIcon />
                </div>
                <div ref={pathRef}>
                  <PrieMenu
                    isMenuOpen={isMenuPathWeight}
                    alldata={pathWeightList}
                    handleCheckboxChange={handleChangePathWeight}
                    checked={pathWeight}
                    isSearch={false}
                  />
                </div>
              </div>
              {
                <Button
                  onClick={handleSearchCrie}
                  className="crie-filter-inner-container-search"
                >
                  Search
                </Button>
              }

              {/* Reset Filter */}
              {
                <div className="crie_outer_drop">
                  <div
                    className="inner-rest-button-crie"
                    onClick={handleResetFilter}
                  >
                    <ReplayIcon className="reset-tick-icon" />
                    Reset Filter
                  </div>
                </div>
              }
            </div>
            {disabledIndirect === "pending" ? (
              <Button
                className="crie-filter-inner-container-crie"
                onClick={() => setModalOpen(true)}
              >
                Enable Indirect Connection Paths
              </Button>
            ) : null}
            {disabledIndirect === "submitted" ? (
              <div className="crie_indirect_process">
                <p>Indirect Paths In Process</p>
                <Button className="crie-filter-inner-container-crie-disabled">
                  Enable Indirect Connection Paths
                </Button>
              </div>
            ) : null}
            {disabledIndirect === "processing" ? (
              <Button
                className="crie-filter-inner-container-crie"
                onClick={() => setModalOpenRefresh(true)}
              >
                Refresh Indirect Paths
              </Button>
            ) : null}
            {disabledIndirect === "refresh" ? (
              <div className="crie_indirect_process">
                <p>Indirect Paths In Process</p>
                <Button className="crie-filter-inner-container-crie-disabled">
                  Refresh Indirect Paths
                </Button>
              </div>
            ) : null}
          </div>
          <div className="crie-filter-inner-container cre-list-cont">
            <div className="crie-inner-drop-boxes-2">
              {joassociate?.length ? (
                <>
                  {joassociate?.map((item) => (
                    <div className="crie_selected_names">
                      {joAssociateList?.find((i) => i?.value == item)?.name}{" "}
                      <CloseOutlined
                        onClick={() =>
                          setJoassociate(
                            joassociate?.filter((uncheck) => uncheck !== item),
                          )
                        }
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </div>

            <div className="crie-inner-drop-boxes-2">
              {pathWeight?.length ? (
                <>
                  {pathWeight?.map((item) => (
                    <div className="crie_selected_names">
                      {
                        pathWeightList?.find(
                          (i) =>
                            i?.value?.[0] == item?.[0] &&
                            i?.value?.[1] == item?.[1],
                        )?.name
                      }{" "}
                      <CloseOutlined
                        onClick={() =>
                          setPathWeight(
                            pathWeight?.filter((uncheck) => uncheck !== item),
                          )
                        }
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </div>
          </div>
          {/* <div className='crie-cont crie_direct'>Direct Connection Paths</div> */}
          <div style={{ padding: isPortrait ? "0px" : "20px" }}>
            <div className="path-graph-crie">
              {/* <div className='radio-input-crie'> <div className='direct-path-crie'><input type="radio" /><p>Direct Paths</p></div> <div className='in-direct-path-crie'><input type="radio" /><p>In-Direct Paths</p></div></div> */}
              <div className="radio-input-crie">
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    className="rg-direct-paths"
                    onChange={(e) => handleRadioChange(e)}
                  >
                    <FormControlLabel
                      className="direct-path-crie"
                      checked={selectedValue === "direct"}
                      value="direct"
                      control={<Radio />}
                      label="Direct Paths"
                    />
                    <FormControlLabel
                      className={
                        disabledIndirect == "pending" ||
                        disabledIndirect === "submitted"
                          ? "in-direct-path-crie"
                          : "direct-path-crie"
                      }
                      checked={selectedValue === "indirect"}
                      value="indirect"
                      disabled={
                        disabledIndirect == "pending" ||
                        disabledIndirect === "submitted"
                      }
                      control={<Radio />}
                      label="Indirect Paths"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {crieData?.length ? (
                <>
                  {crieData
                    .sort((a, b) => b.strength - a.strength)
                    ?.slice(0, visibleItems)
                    ?.map((item, index) => (
                      <div className="crie_path_cont">
                        <div
                          className="first_crie_box"
                          onClick={() => {
                            if (item?.src_org_id) {
                              navigate(`/Profile/${item?.src_id}`);
                            }
                          }}
                        >
                          <div className="crie_info">
                            <div className="crie_name">
                              {item?.src_name}{" "}
                              <p className="formerjo-p">
                                {item.src_former_jo ? (
                                  <img
                                    src={joformarimg}
                                    alt=""
                                    className="jo-former-icon"
                                  />
                                ) : (
                                  ""
                                )}
                              </p>{" "}
                            </div>
                            <div>Jobs Ohio</div>
                            <a className="company-profile-mention">
                              {" "}
                              <EmailOutlinedIcon
                                style={{
                                  color: "#003057",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />{" "}
                              {item?.src_email
                                ? item?.src_email.split(",")[0]
                                : "--"}
                            </a>
                            <a className="company-profile-mention">
                              {" "}
                              <img
                                src={phone}
                                alt=""
                                style={{ width: "13px", height: "13px" }}
                              />
                              {item?.src_phone ? item?.src_phone : "--"}{" "}
                            </a>
                            <p className="company-profile-mention-2">
                              <span>
                                <img
                                  src={linkedin}
                                  alt=""
                                  style={{ width: "14px", height: "14px" }}
                                />
                                {item?.src_linkedin ? "Linkedin Profile" : "--"}
                              </span>
                              {item?.src_linkedin ? (
                                <a
                                  href={item?.src_linkedin}
                                  target="_blank"
                                  className="crie-a-end"
                                >
                                  {" "}
                                  <img
                                    src={visitLinkImage}
                                    alt=""
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </a>
                              ) : (
                                <a></a>
                              )}{" "}
                            </p>
                          </div>
                        </div>
                        <div className="crie_line">
                          {/* {
                                                item?.last_date ?
                                                    <div className='crie-days'>{getDaysDifference(item?.last_date)}</div> : null
                                            } */}
                          {item?.last_date && item?.last_date !== "-" ? (
                            <div
                              className="crie-days"
                              style={{
                                background: getDaysDifference(item.last_date)
                                  .color,
                              }}
                            >
                              {getDaysDifference(item?.last_date).text}
                            </div>
                          ) : null}
                          <div className="crie-img">
                            <Tooltip title={"Weighted Connection Strength"}>
                              <div className="weight-between-nodes-crie">
                                {item?.strength}
                              </div>
                            </Tooltip>
                            {item?.connection_types?.includes("Email") ? (
                              <Tooltip title={"Email Exchanged"}>
                                <img
                                  src={massageicon}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("LinkedIn") ? (
                              <Tooltip title={"LinkedIn Connection"}>
                                <img
                                  src={LinkedINImage}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}
                            {item?.connection_types?.includes(
                              "Organization",
                            ) ? (
                              <Tooltip title={"Working in Same Organization"}>
                                <img
                                  src={company}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Education") ? (
                              <Tooltip title={"Attended Same College"}>
                                <img
                                  src={education}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Experience") ? (
                              <Tooltip
                                title={"Previously Worked in Same Organization"}
                              >
                                <img
                                  src={experience}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}

                            {item?.connection_types?.includes("Meeting") ? (
                              <Tooltip title={"Meeting"}>
                                <CalendarMonthIcon className="siderbar-modal-img" />
                              </Tooltip>
                            ) : null}
                            {item?.connection_types?.includes("Partner") ? (
                              <Tooltip title={"Regional Partner"}>
                                <img
                                  src={partnerimg}
                                  alt=""
                                  className="siderbar-modal-img"
                                />
                              </Tooltip>
                            ) : null}
                          </div>
                        </div>
                        <div
                          className="first_crie_box"
                          onClick={() => {
                            if (item?.dst_org_id) {
                              navigate(`/Profile/${item?.dst_id}`);
                            }
                          }}
                        >
                          <div className="crie_info">
                            <div className="crie_name">
                              {item?.dst_name}{" "}
                              <p className="formerjo-p">
                                {item.dst_former_jo ? (
                                  <img
                                    src={joformarimg}
                                    alt=""
                                    className="jo-former-icon"
                                  />
                                ) : (
                                  ""
                                )}
                              </p>{" "}
                            </div>
                            <div className="crie_name">
                              {dataForInformation?.name}
                            </div>
                            <a className="company-profile-mention">
                              {" "}
                              <EmailOutlinedIcon
                                style={{
                                  color: "#003057",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />{" "}
                              {item?.dst_email ? item?.dst_email : "--"}{" "}
                            </a>
                            <a className="company-profile-mention">
                              {" "}
                              <img
                                src={phone}
                                alt=""
                                style={{ width: "13px", height: "13px" }}
                              />
                              {item?.dst_phone ? item?.dst_phone : "--"}
                            </a>
                            <p className="company-profile-mention-2">
                              <span>
                                <img
                                  src={linkedin}
                                  alt=""
                                  style={{ width: "14px", height: "14px" }}
                                />
                                {item?.dst_linkedin ? "Linkedin Profile" : "--"}
                              </span>{" "}
                              {item?.dst_linkedin ? (
                                <a
                                  href={item?.dst_linkedin}
                                  className="crie-a-end"
                                  target="_blank"
                                >
                                  {" "}
                                  <img
                                    src={visitLinkImage}
                                    alt=""
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </a>
                              ) : null}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <div className="crie_path_cont">No Records Found !</div>
              )}
              <div className="loadmore-pagination-section">
                {visibleItems < crieData?.length ? (
                  <button
                    className="btn-load-more button-loadmore-pagination crie-load-more"
                    onClick={handleLoadMore}
                  >
                    Load More
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PrieDirectPath;
